// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bPrincipal[data-v-6da5c068]{float:right}.dBtn[data-v-6da5c068]{margin-bottom:15px}", ""]);
// Exports
module.exports = exports;
